import i18n from "../i18n";
import { DateTime } from "luxon";
import { toDateString } from "./date";

enum Month {
  January = "January",
  February = "February",
  March = "March",
  April = "April",
  May = "May",
  June = "June",
  July = "July",
  August = "August",
  September = "September",
  October = "October",
  November = "November",
  December = "December",
}

export default Month;

export enum DateSorting {
  All = "All",
  January = "January",
  February = "February",
  March = "March",
  April = "April",
  May = "May",
  June = "June",
  July = "July",
  August = "August",
  September = "September",
  October = "October",
  November = "November",
  December = "December",
}

export const getLabeledMonths = () => {
  return [
    {
      index: 1,
      value: Month.January,
      label: i18n.t("January"),
      labelShort: i18n.t("month-short-January"),
    },
    {
      index: 2,
      value: Month.February,
      label: i18n.t("February"),
      labelShort: i18n.t("month-short-February"),
    },
    {
      index: 3,
      value: Month.March,
      label: i18n.t("March"),
      labelShort: i18n.t("month-short-March"),
    },
    {
      index: 4,
      value: Month.April,
      label: i18n.t("April"),
      labelShort: i18n.t("month-short-April"),
    },
    {
      index: 5,
      value: Month.May,
      label: i18n.t("May"),
      labelShort: i18n.t("month-short-May"),
    },
    {
      index: 6,
      value: Month.June,
      label: i18n.t("June"),
      labelShort: i18n.t("month-short-June"),
    },
    {
      index: 7,
      value: Month.July,
      label: i18n.t("July"),
      labelShort: i18n.t("month-short-July"),
    },
    {
      index: 8,
      value: Month.August,
      label: i18n.t("August"),
      labelShort: i18n.t("month-short-August"),
    },
    {
      index: 9,
      value: Month.September,
      label: i18n.t("September"),
      labelShort: i18n.t("month-short-September"),
    },
    {
      index: 10,
      value: Month.October,
      label: i18n.t("October"),
      labelShort: i18n.t("month-short-October"),
    },
    {
      index: 11,
      value: Month.November,
      label: i18n.t("November"),
      labelShort: i18n.t("month-short-November"),
    },
    {
      index: 12,
      value: Month.December,
      label: i18n.t("December"),
      labelShort: i18n.t("month-short-December"),
    },
  ];
};

export const getMonthLabel = (month: Month) => {
  const labeledMonths = getLabeledMonths();
  return labeledMonths.find((l) => l.value === month)?.label;
};

export const getLabeledMonthForMonthIndex = (monthIndex: number) => {
  const labeledMonths = getLabeledMonths();
  return labeledMonths.find((l) => l.index === monthIndex)?.labelShort;
};

export const getMonthList = () => {
  return Object.keys(Month);
};

export const isMonth = (monthString: string) => {
  return Object.values(Month).some((m: string) => m === monthString);
};

export const getMonthLabelOrNull = (monthString: string) => {
  if (!isMonth(monthString)) {
    return null;
  }
  const labeledMonths = getLabeledMonths();
  return labeledMonths.find((l) => l.value === (monthString as Month));
};

export const getSortingChoices = () => Object.values(DateSorting).map((d) => ({ value: d, label: i18n.t(d) }));

export const getCurrentMonth = () => {
  const monthIndex = DateTime.now().month;

  const labeledMonths = getLabeledMonths();
  return labeledMonths.find((l) => l.index === monthIndex)?.value as Month;
};

export const getCurrentMonthRange = () => {
  const start = DateTime.fromObject({ year: DateTime.now().year, month: DateTime.now().month, day: 1 });
  const end = start.endOf("month");

  return { start: toDateString(start), end: toDateString(end) };
};

export const getLastThreeMonths = () => {
  const now = DateTime.now();
  return [2, 1, 0].map(offset => {
    const dt = now.minus({ months: offset });
    const labeled = getLabeledMonths().find(l => l.index === dt.month)!;

    return {
      index: dt.month,
      value: labeled.value,
      label: labeled.labelShort,
      start: DateTime.fromObject({ year: dt.year, month: dt.month, day: 1 }),
      end: DateTime.fromObject({ year: dt.year, month: dt.month, day: 1 }).endOf("month"),
    };
  });
};